module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/object/assign.js
// module id = 29
// module chunks = 0 1 2